import React from 'react'

import { Gallery } from '@cms/ui'
import Head from '../../head'

const Page = (props) => {
  if (!props.data) return null
  const { zh_name, en_name, desc: d, thumbnail, works } = props.data
  const desc = `"${en_name}", Chan Kwan-Lok's creations, also named "${zh_name}". Details: ${d}`

  return (
    <>
      <Head
        title={`${en_name} | ${zh_name}`}
        desc={desc}
        img={`${process.env.NEXT_IMAGE_ENDPOINT}/${thumbnail.hash}`}
        ogTitle={`${en_name} | ${zh_name}`}
      />
      <div className="row series-page">
        <div className="column title">
          <h3>{zh_name}</h3>
          <h1>{en_name}</h1>
          <p>{d}</p>
        </div>
      </div>
      <Gallery items={works} />
    </>
  )
}

export default Page

export async function getStaticProps({ params, preview = false }) {
  const { parseData, fetchSeries } = await import('../../data')

  const data = parseData(await fetchSeries(params.slug), 'serieses')

  return {
    props: {
      preview,
      data: data,
    },
  }
}

export async function getStaticPaths() {
  const { fetchSerieses } = await import('../../data')

  const slugs = await fetchSerieses()

  return {
    paths: slugs.map((id) => ({
      params: {
        slug: String(id),
      },
    })),
    fallback: false,
  }
}
